import React, { useState } from 'react';
import './Testimonials.css';
import { testimonialsData } from '../../data/testimonialsData';
import leftArrow from '../../assets/leftArrow.png';
import rightArrow from '../../assets/rightArrow.png';
import { motion } from 'framer-motion';
import gal1 from '../../assets/gal1.png';
import gal2 from '../../assets/gal2.png';
import gal3 from '../../assets/gal3.png';
import gal4 from '../../assets/gal4.png';

const Testimonials = () => {
  const transition = { type: 'spring', duration: 1.5 };
  const [selected, setSelected] = useState(0);
  const [selectedGallery, setSelectedGallery] = useState(0);
  const tLength = testimonialsData.length;
  const galleryImages = [gal1, gal2, gal3, gal4];
  const gLength = galleryImages.length;

  return (
    <div className='testimonials-container'>
      {/* Testimonials Section */}
      <div className='testimonials'>
        <div className='left-t'>
          <span>Testimonials</span>
          <span className='stroke-text'>What they</span>
          <span>say about us</span>
          <motion.span
            key={selected}
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 100 }}
            transition={transition}
          >
            {testimonialsData[selected].review}
          </motion.span>
          <span>
            <span style={{ color: 'var(--orange)' }}>
              {testimonialsData[selected].name}
            </span>{" "}
            - {testimonialsData[selected].status}
          </span>
        </div>
        <div className="right-t">
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            transition={{ ...transition, duration: 2 }}
            whileInView={{ opacity: 1, x: 0 }}
            className="decorative-bg"
          ></motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            transition={{ ...transition, duration: 2 }}
            whileInView={{ opacity: 1, x: 0 }}
            className="decorative-border"
          ></motion.div>
          
          <motion.img 
            key={selected}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={transition}
            src={testimonialsData[selected].image} 
            alt={testimonialsData[selected].name}
            className="testimonial-image"
          />
          
          <div className="arrows">
            <img 
              onClick={() => setSelected(selected === 0 ? tLength-1 : selected-1)}
              src={leftArrow} 
              alt="Previous" 
            />
            <img 
              onClick={() => setSelected(selected === tLength-1 ? 0 : selected+1)}
              src={rightArrow} 
              alt="Next" 
            />
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className='testimonials gallery-section'>
        <div className='left-t'>
          <span>TAKE A TOUR OF OUR FACILITY</span>
          <span className='stroke-text'>See our</span>
          <span>world-class gym</span>
        </div>
        <div className="right-t">
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            transition={{ ...transition, duration: 2 }}
            whileInView={{ opacity: 1, x: 0 }}
            className="decorative-bg"
          ></motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            transition={{ ...transition, duration: 2 }}
            whileInView={{ opacity: 1, x: 0 }}
            className="decorative-border"
          ></motion.div>
          
          <motion.img 
            key={selectedGallery}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={transition}
            src={galleryImages[selectedGallery]} 
            alt={`Gallery image ${selectedGallery + 1}`}
            className="testimonial-image"
          />
          
          <div className="arrows">
            <img 
              onClick={() => setSelectedGallery(selectedGallery === 0 ? gLength-1 : selectedGallery-1)}
              src={leftArrow} 
              alt="Previous" 
            />
            <img 
              onClick={() => setSelectedGallery(selectedGallery === gLength-1 ? 0 : selectedGallery+1)}
              src={rightArrow} 
              alt="Next" 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;